var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinOuterLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26.6377C5.8203 26.6377 0 20.8174 0 13.6377C0 6.45799 5.8203 0.637695 13 0.637695C20.1797 0.637695 26 6.45799 26 13.6377C26 20.8174 20.1797 26.6377 13 26.6377ZM13 24.6377C19.0751 24.6377 24 19.7128 24 13.6377C24 7.56256 19.0751 2.6377 13 2.6377C6.92487 2.6377 2 7.56256 2 13.6377C2 19.7128 6.92487 24.6377 13 24.6377ZM25 26.6377C17.8203 26.6377 12 20.8174 12 13.6377C12 6.45799 17.8203 0.637695 25 0.637695C32.1797 0.637695 38 6.45799 38 13.6377C38 20.8174 32.1797 26.6377 25 26.6377ZM25 24.6377C31.0751 24.6377 36 19.7128 36 13.6377C36 7.56256 31.0751 2.6377 25 2.6377C18.9249 2.6377 14 7.56256 14 13.6377C14 19.7128 18.9249 24.6377 25 24.6377Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3656 23.3563C14.6072 23.5402 13.815 23.6377 13 23.6377C7.47715 23.6377 3 19.1605 3 13.6377C3 8.11485 7.47715 3.6377 13 3.6377C13.815 3.6377 14.6072 3.73519 15.3656 3.91914C12.6873 6.30038 11 9.77199 11 13.6377C11 17.5034 12.6873 20.975 15.3656 23.3563Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinOuterLeftIcon);
export default __webpack_public_path__ + "static/media/join-outer-left-icon.1ea34b3b29d3d7b39c452bc001a92a40.svg";
export { ForwardRef as ReactComponent };